module.exports = __webpack_public_path__ + "static/media/strongher15.50a26a67.jpg";